import api from "../index";

export const GetAllTutorialApi = (params) => api.get(`Tutorial/Get-All-Tutorial?${params}`);
export const GetTutorialTypeApi = () => api.get('Tutorial/Get-Tutorial-Types');
export const AddTutorialApi = (data, apiHeader) => api.post('Tutorial/Add-Update', data, apiHeader);
export const UpdateTutorialStatusApi = (data) => api.put('Tutorial/Active-Inactive', data);
export const DeleteTutorialApi = (tutorialId) => api.delete(`Tutorial/Delete/${tutorialId}`);